// NOTE(mike): In Express 5, the wildcard path can no longer be '*'.
// See: https://expressjs.com/en/guide/migrating-5.html
export const WILDCARD_PATH = '*splat';

export const JOBS_ROUTE = '/jobs';
export const ORDERS_ROUTE = '/orders';
export const SHIPMENTS_ROUTE = '/shipments';
export const CALLS_ROUTE = '/calls';
export const CHATS_ROUTE = '/chats';
export const CONVERSATIONS_ROUTE = '/conversations';
export const ACTIVITY_ROUTE = '/activity';
export const CALLS_DEBUG_ROUTE = `${CALLS_ROUTE}/debug`;
export const ORIGINATORS_ROUTE = '/originators';
export const ORGANIZATIONS_ROUTE = '/organizations';
export const ORGANIZATION_SETTINGS_ROUTE = '/organizationSettings';
export const TEAMS_ROUTE = '/teams';
export const PLACES_ROUTE = '/places';
export const QUOTES_ROUTE = '/quotes';
export const USERS_ROUTE = '/users';
export const LABELS_ROUTE = '/labels';
export const INSIGHTS_ROUTE = '/insights';
export const FEATURE_FLAGS_ROUTE = '/featureFlags';
export const SOPS_ROUTE = '/sops';
export const SOPS_EDITOR_ROUTE = `${SOPS_ROUTE}/editor`;
export const TASKS_ROUTE = '/tasks';
export const MISSING_PRODUCT_ENTITLEMENT_ROUTE = '/missingProductEntitlement';
export const KNOWLEDGE_BASE_ROUTE = '/knowledge-bases';
export const SHARED_FILES_ROUTE = '/shared-files';
export const MEMORIES_ROUTE = '/memories';
export const TMS_SIDEKICK_ROUTE = '/tms-sidekick';
export const WORKERS_ROUTE = '/workers';
export const ADMIN_ROUTE = '/admin';
export const ADMIN_TRACK_ROUTE = '/admin/track';
export const CARRIERS_ROUTE = '/carriers';
export const CARRIER_DIRECTORY_ROUTE = '/carrier-directory';
export const COVER_ROUTE = '/cover';
export const SCHEDULE_ROUTE = '/schedule';
export const RULES_ROUTE = '/rules';
export const TRACK_ROUTE = '/track';
export const ESCALATIONS_ROUTE = '/escalations';

/**
 * Routes accessible to different hierarchical roles
 */
export const USER_LEVEL_ROUTES = [
  ORDERS_ROUTE,
  QUOTES_ROUTE,
  CALLS_ROUTE,
  CHATS_ROUTE,
  SCHEDULE_ROUTE,
  MISSING_PRODUCT_ENTITLEMENT_ROUTE,
  TASKS_ROUTE,
];
export const SUPPORT_LEVEL_ROUTES = [
  ...USER_LEVEL_ROUTES,
  JOBS_ROUTE,
  ORIGINATORS_ROUTE,
  LABELS_ROUTE,
];
export const ADMIN_LEVEL_ROUTES = [
  ...SUPPORT_LEVEL_ROUTES,
  CARRIERS_ROUTE,
  CARRIER_DIRECTORY_ROUTE,
  ORGANIZATIONS_ROUTE,
  PLACES_ROUTE,
  USERS_ROUTE,
  ADMIN_ROUTE,
  ADMIN_TRACK_ROUTE,
];
